module.exports = function (gsap, SplitText) {

    if (document.querySelector('.home-hero__title')) {
        /**
         * Animation title
         */
        var tlTitle = gsap.timeline(),
            split = new SplitText(".home-hero__title", {
                type: "words, chars"
            }),
            chars = split.chars;

        tlTitle
            .fromTo('.home-hero__content', {
                autoAlpha: 0
            }, {
                autoAlpha: 1
            }, '+=0.5')
            .from(chars, {
                duration: 0.35,
                opacity: 0,
                yPercent: 40,
                ease: "back",
                stagger: 0.05
            })
            .fromTo('.home-hero__popup-button', {
                autoAlpha: 0,
                yPercent: 50
            }, {
                autoAlpha: 1,
                yPercent: 0,
                duration: 0.35,
            })
            .fromTo('.home-hero__nav', {
                autoAlpha: 0
            }, {
                autoAlpha: 1
            })
            .fromTo('.home-hero__nav__item', {
                autoAlpha: 0,
                yPercent: 50
            }, {
                autoAlpha: 1,
                yPercent: 0,
                duration: 0.35,
                stagger: 0.2
            })

        /**
         * Nav links
         */
        const btns = document.querySelectorAll('.home-hero__nav__link');

        btns.forEach(btn => {
            const btnText = btn.children[0],
                btnWrapLetters = btn.children[1],
                btnLetters = new SplitText(btn.children[1], {
                    type: "chars"
                }),
                tlBtn = gsap.timeline({
                    paused: true
                });

            tlBtn
                .to(btnText, {
                    opacity: 0,
                    yPercent: -50,
                    duration: 0.5,
                    ease: "back.out(1.7)"
                })
                .from(btnWrapLetters, {
                    yPercent: 10
                }, '-=0.6')
                .from(btnLetters.chars, {
                    duration: 0.35,
                    opacity: 0,
                    yPercent: 40,
                    ease: "back.out(1.7)",
                    stagger: 0.05
                }, '-=0.6')

            btn.addEventListener("mouseover", () => {
                tlBtn.play().timeScale(1);
            })

            btn.addEventListener("mouseleave", () => {
                tlBtn.timeScale(2).reverse();
            })
        });
    }

};